import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/saint-info")({
  beforeLoad: () => {
    throw redirect({ to: "/saint" });
  },
});
